import React from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Outlet,
  Route,
  RouterProvider
} from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import 'bootstrap/dist/css/bootstrap.min.css';

import { ModalContextProvider } from 'Common/contexts/ModalContext';
import { NotificationContextProvider } from 'Common/contexts/NotificationContext';
import { OrdersContextProvider } from 'Compass/contexts/OrdersContext';
import { SuggestionsContextProvider } from 'Compass/contexts/SuggestionsContext';
import { UserContextProvider } from 'Compass/contexts/UserContext';
import MainLayout from 'Compass/core/MainLayout';
import PromptEditorPage from 'Compass/pages/PromptEditorPage';
import IdeaLabPage from 'Compass/pages/IdeaLabPage';
import DashboardPage from 'Compass/pages/DashboardPage';
import OrdersPage from 'Compass/pages/OrdersPage';
import OrderPage from 'Compass/pages/OrderPage';
import OrderSuggestionPage from 'Compass/pages/OrderSuggestionPage';
import OrderSuggestionsPage from 'Compass/pages/OrderSuggestionsPage';
import ProfileLabPage from 'Compass/pages/ProfileLabPage';
import ReverePage from 'Compass/pages/ReverePage';
import ProfileLabSubjectPage from 'Compass/profile-lab/pages/ProfileLabSubjectPage';
import ProfileLabSamplePage from 'Compass/profile-lab/pages/ProfileLabSamplePage';
import ProfileLabPeoplePage from 'Compass/profile-lab/pages/ProfileLabPeoplePage';
import ProfileLabCalendarPage from 'Compass/profile-lab/pages/ProfileLabCalendarPage';
import ProfileLabMapPage from 'Compass/profile-lab/pages/ProfileLabMapPage';
import ProfileLabSelectionPage from 'Compass/profile-lab/pages/ProfileLabSelectionPage';
import ProfileLabStagePage from 'Compass/profile-lab/pages/ProfileLabStagePage';
import ProfileLabChatPage from 'Compass/profile-lab/pages/ProfileLabChatPage';
import ClusteringLabPage from 'Compass/clustering-lab/pages/ClusteringLabPage';
import EvalPage from 'Compass/pages/EvalPage';
import UserViewPage from 'Compass/pages/UserViewPage';

import './App.css';

const ContextStack = () => <>
  <QueryParamProvider adapter={ReactRouter6Adapter} options={{ enableBatching: true }}>
    <UserContextProvider>
        <ModalContextProvider>
          <NotificationContextProvider>
            <OrdersContextProvider>
              <SuggestionsContextProvider>
                <Outlet />
              </SuggestionsContextProvider>
            </OrdersContextProvider>
          </NotificationContextProvider>
        </ModalContextProvider>
    </UserContextProvider>
  </QueryParamProvider>
</>;

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route element={<ContextStack />}>
        <Route element={<MainLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/order/:orderId" element={<OrderPage />} />
          <Route path="/suggestions/" element={<OrderSuggestionsPage />} />
          <Route path="/order_suggestion/:suggestionId" element={<OrderSuggestionPage />} />
          <Route path="/prompt" element={<PromptEditorPage />} />
          <Route path="/idea-lab" element={<IdeaLabPage />} />
          <Route path="/oauth/callback" element={<></>} />
          <Route path="/profile-lab" element={<ProfileLabPage />}>
            <Route index element={<ProfileLabSubjectPage />} />
            <Route path="subject" element={<ProfileLabSubjectPage />} />
            <Route path="sample" element={<ProfileLabSamplePage />} />
            <Route path="people" element={<ProfileLabPeoplePage />} />
            <Route path="calendar" element={<ProfileLabCalendarPage />} />
            <Route path="map" element={<ProfileLabMapPage />} />
            <Route path="selection" element={<ProfileLabSelectionPage />} />
            <Route path="stage" element={<ProfileLabStagePage />} />
            <Route path="chat" element={<ProfileLabChatPage />} />
          </Route>
          <Route path="/clustering-lab" element={<ClusteringLabPage />} />
          <Route path="/eval" element={<EvalPage />} />
          <Route path="/revere" element={<ReverePage />} />
          <Route path="/user-view" element={<UserViewPage />} />
          <Route path="/user-view/:userLid" element={<UserViewPage />} />
          <Route path="*" element={<Navigate to="/prompt" replace />} />
        </Route>
      </Route>
    )
  );

  return <RouterProvider router={router} />;
}

export default App;
